import React, {Component} from 'react';
import PulsoidClient from '../../PulsoidClient';
import {Statistics} from './Statistics';
import {Premium} from './Premium';
import {MenuItemContainer} from '../../system/menu';
import {Col} from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import {Updates} from './Updates';
import {FeatureDisabler, WELCOME_REFERRAL} from '../../system/FeatureDisabler';
import {Referral} from './Referral';
import {DashboardRow} from './utils';
import {Coupon} from './Coupon';
import {StreamingStatusV2} from './CurrentStatusV2';

export class Dashboard extends Component {
  client = new PulsoidClient();
  state = {};

  componentDidMount() {
    this.client.getUserInfo().then((userInfo) => {
      this.setState({
        wsAverage: userInfo.endpoints.average,
        wsListen: userInfo.endpoints.listen,
        referralUrl: userInfo.referralUrl,
      });
    });
    this.client.getCoupons().then(({coupons}) => {
      this.setState({coupons});
    });
    this.client.getPremiumInfo().then((premium) => this.setState({premium}));
  }

  render() {
    return (
      <MenuItemContainer title={'Dashboard'}>
        <Row>
          <Col>
            <StreamingStatusV2 />
            <Statistics client={this.client} />
            <DashboardRow header="Features">
              <Premium />
            </DashboardRow>
            <Coupon coupons={this.state.coupons} premium={this.state.premium} />
            {this.state.referralUrl && (
              <FeatureDisabler feature={WELCOME_REFERRAL}>
                <Referral referralUrl={this.state.referralUrl} />
              </FeatureDisabler>
            )}
          </Col>
          <Col>
            <Updates />
          </Col>
        </Row>
      </MenuItemContainer>
    );
  }
}
